import { combineReducers } from "redux";
import { API } from "../../../../../const";
import _ from "lodash";
import { unAuthorized } from "../../../../auth/Auth.ducks";
import { Service } from "../../../../service/service";

export const GET_DOCUMENTS_PENDING = "GET_DOCUMENTS_PENDING";
export const GET_DOCUMENTS_REJECTED = "GET_DOCUMENTS_REJECTED";
export const GET_DOCUMENTS_FULFILLED = "GET_DOCUMENTS_FULFILLED";

export const ADD_DOCUMENT_PENDING = "ADD_DOCUMENT_PENDING";
export const ADD_DOCUMENT_REJECTED = "ADD_DOCUMENT_REJECTED";
export const ADD_DOCUMENT_FULFILLED = "ADD_DOCUMENT_FULFILLED";

export const DELETE_DOCUMENT_PENDING = "DELETE_DOCUMENT_PENDING";
export const DELETE_DOCUMENT_REJECTED = "DELETE_DOCUMENT_REJECTED";
export const DELETE_DOCUMENT_FULFILLED = "DELETE_DOCUMENT_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case GET_DOCUMENTS_PENDING:
      return true;
    case GET_DOCUMENTS_REJECTED:
    case GET_DOCUMENTS_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case GET_DOCUMENTS_PENDING:
    case GET_DOCUMENTS_FULFILLED:
      return null;
    case GET_DOCUMENTS_REJECTED:
      return payload;
    default:
      return state;
  }
};

const data = (state = { documents: [], count: 0, maxDocuments: 10, maxFileSizeBytes: 5242880 }, { type, payload }) => {
  switch (type) {
    case GET_DOCUMENTS_FULFILLED:
      return _.isEmpty(payload.data) ? state : payload.data;
    default:
      return state;
  }
};

export default combineReducers({ loading, error, data });

export const getDocuments = (tok, idEnfant) => {
  return (dispatch) => {
    dispatch({ type: GET_DOCUMENTS_PENDING });
    const response = Service.get(
      `${API}api/enfant/creche/enfants/${idEnfant}/documents`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: GET_DOCUMENTS_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_DOCUMENTS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const addDocument = (tok, idEnfant, documentData) => {
  return (dispatch) => {
    dispatch({ type: ADD_DOCUMENT_PENDING });
    const response = Service.post(
      `${API}api/enfant/creche/enfants/${idEnfant}/documents`,
      documentData,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: ADD_DOCUMENT_FULFILLED, payload: res });
      dispatch(getDocuments(tok, idEnfant));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: ADD_DOCUMENT_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const deleteDocument = (tok, idEnfant, documentId) => {
  return (dispatch) => {
    dispatch({ type: DELETE_DOCUMENT_PENDING });
    const response = Service.deleteOne(
      `${API}api/enfant/creche/enfants/${idEnfant}/documents/${documentId}`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: DELETE_DOCUMENT_FULFILLED, payload: res });
      dispatch(getDocuments(tok, idEnfant));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: DELETE_DOCUMENT_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
